<template>
  <div class="page">
    <Nav v-if="!isMobile"></Nav>
    <Banner :is-mobile="isMobile"></Banner>
    <Footer v-if="!isMobile"></Footer>
  </div>
</template>

<script setup>
import { ref, onUnmounted } from 'vue';
import Nav from './components/nav.vue';
import Banner from './components/banner.vue';
import Footer from './components/footer.vue';
import { logEvent } from '@/utils/analytics';

const mobileQuery = window.matchMedia('(max-width: 768px)');
const isMobile = ref(mobileQuery.matches);
const updateViewport = () => (isMobile.value = mobileQuery.matches);
mobileQuery.addListener(updateViewport);
onUnmounted(() => mobileQuery.removeListener(updateViewport));

logEvent('official_uv');
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';

.page {
  position: relative;
  margin: 0 auto;
  max-width: $pc-max-width;
  min-width: $pc-main-max-width;
  background: #190c05;
}

@media (max-width: 768px) {
  .page {
    max-width: $mobile-max-width;
    min-width: $mobile-main-width;
  }
}
</style>
